import { render, staticRenderFns } from "./MenuLateral.vue?vue&type=template&id=f2fb28a4&scoped=true"
import script from "./MenuLateral.vue?vue&type=script&lang=js"
export * from "./MenuLateral.vue?vue&type=script&lang=js"
import style0 from "./MenuLateral.vue?vue&type=style&index=0&id=f2fb28a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fb28a4",
  null
  
)

export default component.exports